import { EventForm } from '@/components/enc/event-form';

const AddPage = () => <EventForm />;

export default AddPage;
